import { render, staticRenderFns } from "./BulkSubmissionResult.vue?vue&type=template&id=49906528&scoped=true"
import script from "./BulkSubmissionResult.vue?vue&type=script&lang=js"
export * from "./BulkSubmissionResult.vue?vue&type=script&lang=js"
import style0 from "./BulkSubmissionResult.vue?vue&type=style&index=0&id=49906528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49906528",
  null
  
)

export default component.exports